var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26126",
    d: "M32 24a8 8 0 1 0 8 8 8 8 0 0 0-8-8zm-2.028 11.077h4.057A9.269 9.269 0 0 1 32 38.761a9.269 9.269 0 0 1-2.028-3.684zm-.279-1.231a11.209 11.209 0 0 1 0-3.692h4.615a11.209 11.209 0 0 1 0 3.692zM25.231 32a6.739 6.739 0 0 1 .256-1.846h2.958a12.445 12.445 0 0 0 0 3.692h-2.958A6.739 6.739 0 0 1 25.231 32zm8.8-3.077h-4.059A9.269 9.269 0 0 1 32 25.239a9.269 9.269 0 0 1 2.028 3.684zm1.526 1.231h2.958a6.781 6.781 0 0 1 0 3.692h-2.96a12.445 12.445 0 0 0 0-3.692zm2.474-1.231H35.3a10.953 10.953 0 0 0-1.558-3.462 6.8 6.8 0 0 1 4.286 3.462zm-7.773-3.462a10.953 10.953 0 0 0-1.558 3.462h-2.728a6.8 6.8 0 0 1 4.283-3.461zm-4.284 9.615H28.7a10.953 10.953 0 0 0 1.558 3.462 6.8 6.8 0 0 1-4.284-3.462zm7.773 3.462a10.953 10.953 0 0 0 1.553-3.461h2.725a6.8 6.8 0 0 1-4.28 3.461z",
    transform: "translate(-24 -24)",
    style: {
      fill: "#3f54d9"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.b3cb73896edfc95eec16027bf32578b5.svg";
export { ForwardRef as ReactComponent };